<div class="dialog-container dialog-container--width">
    <div class="dialog-title-block">
        <h2>Confirm Status Reset?</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block p-4">
        <div>
            <p class="text-para text-light-dark">Are you sure you want to reset the consumed status of this implant “<span class="text-link text-primary text-decoration-underline cursor-pointer" (click)="openImplantDialog(this.dialogData.storeId, this.dialogData.implantId)">{{ dialogData.implantName }}</span>” to its previous state? This action will revert any changes made to the product's status manually. Please confirm to proceed or cancel to keep the current status.</p>
        </div>
    </div>
    <div class="dialog-footer">
        <button class="px-4 py-2" type="button" (click)="onClose()">Cancel</button>
        <button class="px-4 py-2" type="submit" (click)="submit()">Confirm</button>
    </div>
</div>

